/**
 * LiveAgentSupport.js was created to encapsulated all functionality related
 * with retrieving Live Agent information from Salesforce
 *
 * Usage:
 *  LiveAgentSupport.loadLiveAgent('elementId_forOnlineButton', 'elementId_forOfflineButton');
 *
 * User: crodriguez Date: 12/11/2014
 */
define(function (require) {
    'use strict';

    var $ = require('jquery'),
        _ = require('underscore'),
        Backbone = require('backbone'),
        $script = require('scriptjs'),
        LiveAgentModel = require('components/live-agent/models/LiveAgentModel');

    return {
        loadLiveAgent: function (onlineElementId, offlineElementId) {
            if (!this.model) {
                this.model = new LiveAgentModel();
                this.customerDetailsSet = false;
            }

            this.model.fetch({
                success: _.bind(this._loadSalesforceLiveAgent, this, onlineElementId, offlineElementId)
            });

        },

        _loadSalesforceLiveAgent: function (onlineElementId, offlineElementId) {
            var nls = commonConfig.getLiveAgentNLS().split('-')[0];

            if (!commonConfig.isSupportedLanguage(nls)) {
                $('#' + onlineElementId).hide();
                $('#' + offlineElementId).show();
                return;
            }

            var me = this,
                salesforceLiveAgentDeployment = me.model.get('liveAgentHostJs');

            var _onSalesforceScriptLoad = function () {
                var liveAgentHostChat = me.model.get('liveAgentHostChat'),
                    liveAgentInitId1 = me.model.get('liveAgentInitId1'),
                    liveAgentInitId2 = me.model.get('liveAgentInitId2'),
                    startChatId = me.model.get('liveAgentStartId_' + nls);
                liveagent.setChatWindowHeight(490);

                if (!window._laq) {
                    window._laq = [];
                }
                window._laq.push(function () {
                    liveagent.showWhenOnline(startChatId, $('#' + onlineElementId).get(0));
                    liveagent.showWhenOffline(startChatId, $('#' + offlineElementId).get(0));

                });

                var userName = me.model.get('userName'),
                    userEmail = me.model.get('userEmail');

                if (userName != 'unknown' && !me.customerDetailsSet) {
                    liveagent.addCustomDetail('Contact E-mail', userEmail).map('Contact', 'Email', false, true);
                    liveagent.addCustomDetail('Contact Name', userName).map('Contact', 'Name', true, false);
                    liveagent.addCustomDetail('CaseOrigin', 'Live Chat');
                    liveagent.findOrCreate("Case").map("Origin", "CaseOrigin", false, false, true);
                    liveagent.findOrCreate("Case").showOnCreate();
                    liveagent.findOrCreate("Case").saveToTranscript("CaseId");
                    liveagent.findOrCreate('Contact').map('Email', 'Contact E-mail', true, false,
                        false).linkToEntity("Case", "ContactId").saveToTranscript('contactId');
                    liveagent.setName(userName);
                    me.customerDetailsSet = true;
                }

                liveagent.init(liveAgentHostChat + '/chat', liveAgentInitId1, liveAgentInitId2);

                me._activateChatLink(onlineElementId, offlineElementId, startChatId);
            };

            $script(salesforceLiveAgentDeployment, _onSalesforceScriptLoad);
        },

        _activateChatLink: function (onlineElementId, offlineElementId, startChatId) {
            $("#" + onlineElementId).on("click", function (event) {
                event.preventDefault();
                liveagent.startChat(startChatId);
            });
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./js/common/views/LiveAgentSupport.js
// module id = 119
// module chunks = 14 26